
import { Ingredient } from "@/types/product";
import { supabase } from "@/integrations/supabase/client";

// Get product ingredients
export const getProductIngredients = async (productId: string): Promise<Ingredient[]> => {
  try {
    const { data, error } = await supabase
      .from("product_ingredients")
      .select(`
        ingredient_id,
        ingredients:ingredients(id, name)
      `)
      .eq("product_id", productId);

    if (error) throw error;

    return data.map((item: any) => ({
      id: item.ingredients.id,
      name: item.ingredients.name,
    }));
  } catch (error) {
    console.error("Error fetching product ingredients:", error);
    return [];
  }
};

// Save product ingredients
export const saveProductIngredients = async (
  productId: string,
  ingredientIds: string[]
): Promise<void> => {
  try {
    // First, remove all existing product_ingredients for this product
    const { error: deleteError } = await supabase
      .from("product_ingredients")
      .delete()
      .eq("product_id", productId);

    if (deleteError) throw deleteError;

    // If there are no ingredients to add, we're done
    if (!ingredientIds.length) return;

    // Then, insert the new product_ingredients
    const productIngredients = ingredientIds.map((ingredientId) => ({
      product_id: productId,
      ingredient_id: ingredientId,
    }));

    const { error: insertError } = await supabase
      .from("product_ingredients")
      .insert(productIngredients);

    if (insertError) throw insertError;
  } catch (error) {
    console.error("Error saving product ingredients:", error);
    throw error;
  }
};
